import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import './PageHeader.css';

/**
 * A reusable page header component with title, subtitle, and action buttons
 * Uses BEM naming convention for CSS classes
 */
const PageHeader = ({
  title,
  subtitle,
  leftActions,
  rightActions,
  className = '',
}) => {
  return (
    <div className={`page-header ${className}`}>
      {/* Top actions row */}
      {(leftActions || rightActions) && (
        <div className="page-header__actions">
          <div className="page-header__left-actions">
            {leftActions}
          </div>
          <div className="page-header__right-actions">
            {rightActions}
          </div>
        </div>
      )}

      {/* Title row */}
      <div className="page-header__title-row">
        <div className="page-header__title-container">
          <h2 className="page-header__title">{title}</h2>
        </div>
      </div>

      {/* Subtitle row */}
      {subtitle && (
        <div className="page-header__subtitle-row">
          <p className="page-header__subtitle">{subtitle}</p>
        </div>
      )}
    </div>
  );
};

PageHeader.propTypes = {
  title: PropTypes.string.isRequired,
  subtitle: PropTypes.string,
  leftActions: PropTypes.node,
  rightActions: PropTypes.node,
  className: PropTypes.string
};

export default PageHeader;